import type { ChatMessage } from '../types';

/** Users may edit or hard-delete (soft-delete) only within this window after `createdAt`. */
export const CHAT_EDIT_DELETE_WINDOW_MS = 5 * 60 * 1000;

export function canEditOrDeleteOwnMessage(msg: ChatMessage, userId: string, now = Date.now()): boolean {
  if (msg.authorId !== userId) return false;
  if (msg.pending) return false;
  if (msg.deletedAt) return false;
  return now - msg.createdAt <= CHAT_EDIT_DELETE_WINDOW_MS;
}

export function formatEditDeleteWindowHelp(): string {
  return 'You can edit or delete your message for up to 5 minutes after sending.';
}

/** Preview for list / toast (no audit content for non-admins). */
export function chatMessagePreview(m: ChatMessage): string {
  if (m.deletedAt) return 'Message deleted';
  const t = (m.body || '').trim();
  if (t) return t;
  if (m.attachments?.length) return 'Attachment';
  return '';
}
